import Cookies from 'js-cookie';
import { createRandomValue } from './create-random-value.js';
import { parseLoginState } from './parse-login-state.js';
export function defineLoginService(options) {
    const { authorizePathname, logoutPathname, authorizeStateCookieName, loginStateCookieName, } = options;
    return {
        id: `login-service`,
        dependencies: {
            featureServices: {
                'locale-service': `^3.0.0`,
            },
        },
        optionalDependencies: {
            featureServices: {
                'pub-sub': `^1.0.0`,
            },
        },
        create: ({ featureServices }) => {
            const localeService = featureServices[`locale-service`];
            const pubSubService = featureServices[`pub-sub`];
            const login = () => {
                pubSubService === null || pubSubService === void 0 ? void 0 : pubSubService.publish(`before-login`);
                const { languageTag } = localeService.getLocale();
                const { origin, pathname, search } = document.location;
                const state = JSON.stringify([
                    createRandomValue(),
                    `${pathname}${search}`,
                ]);
                Cookies.set(authorizeStateCookieName, state, { path: `/` });
                const authorizeUrl = new URL(authorizePathname, origin);
                authorizeUrl.searchParams.set(`languageTag`, languageTag);
                window.location.assign(authorizeUrl.href);
            };
            const logout = (redirectPath = window.location.href.replace(window.location.origin, ``)) => {
                window.location.assign(`${logoutPathname}?redirectPath=${encodeURIComponent(redirectPath)}`);
            };
            const loginState = parseLoginState(loginStateCookieName);
            const isLoggedIn = loginState.status === `logged-in`;
            const loginStateV2 = loginState.status === `logged-in`
                ? { uid: loginState.uid, customerType: loginState.customerType }
                : undefined;
            // https://web.dev/bfcache/#update-stale-or-sensitive-data-after-bfcache-restore
            window.addEventListener(`pageshow`, (event) => {
                if (event.persisted &&
                    loginState.status !== parseLoginState(loginStateCookieName).status) {
                    location.reload();
                }
            });
            return {
                '1.0.0': () => ({
                    featureService: { login, logout, isLoggedIn },
                }),
                '2.1.0': () => ({
                    featureService: { login, logout, loginState: loginStateV2 },
                }),
                '3.0.0': () => ({
                    featureService: { login, logout, loginState },
                }),
            };
        },
    };
}
//# sourceMappingURL=index.js.map